import Kedo from "@/Kedo"

export enum BlockTypes {
    Dashboard = 'dashboard',
    SumField = 'sum_fields',
    CountListOptions = 'count_list_options',
    DateStatistics = 'date_statistics',
    CountLinkOptions = 'count_link_options',
    ListOptionPercentageConditions = 'list_option_percentage_conditions',
    KedoCharts = 'kedo_charts',
    BlockContainer = 'block_container',
    OnlineUsers = 'online_users'
}

export type BlockTypeValue = (typeof BlockTypes)[keyof typeof BlockTypes];

export interface Translation { culture: string; title: string; }

export interface BlockItem {
    id: number;
    name: string | null;
    description: string | null;
    def_dossier_id: number | null;
    type: BlockTypeValue;
    parent_id: number | null;
    roles: { id: number; name: string, role_id: number }[] | null;
    translations: Translation[];
    dossier_query_id: number | null;
    col: number;
    rank: number;
    dashboard: boolean;
    settings: SettingsState;
}

export interface Pager {
    currentPage: number;
    lastPage: number;
    total: number;
}

export interface BlocksIndexProps {
    kedo: Kedo;
    history?: any;
}


export interface ItemState {
    id?: number;
    translations: Translation[];
    defDossier: number | null;
    dossierQuery: number | null;
    roles: number[];
    col: number;
    rank: number;
    dashboard: boolean;
    type: BlockTypeValue;
    settings: SettingsState;
    parent_id?: number
}

export interface SettingsState {
    sort: any;
    view_name: string;
    authKey: string | null;
    authToken: string | null;
    dashboardId: string | null;
    show_add: boolean;
    tabQueries: any;
    template: string | null;
    templateOptions: Record<string, any>;
    pie_charts: any;
    list_field: number | null;
    count_list_field: number | null;
    count_link_field: number | null;
    count_link_field_sec: number | null;
    link_field: number | null;
    origin_link_field: number | null;
    scheme: string | null;
    date_field: number | null;
    sum_field: number | null;
    limit: number;
    carousel: boolean;
    use_creation_date: boolean;
    group_format: string | null;
    date_format: string | null;
    chart_format: string | null;
    chart_layout: string | null;
    chart_identifier: string | null;
    table_layout: string | null;
    reverse_axis: string | null;
    show_y_scroll: string | null;
    enable_labels: string | null;
    enable_grid: string | null;
    origin_display_field: number | null;
    link_display_field: number | null;
    legend_direction: string | null;
    layout: string;
    period: string | null;
}

export interface BlockFormState {
    parents?: any[];
    defDossiers: any[];
    dossierQuery: any;
    countLinkDefDossier: number | null;
    countLinkDefDossierSec: number | null;
    originLinkDefDossier: number | null;
    dossierQueries: any[];
    delete: boolean;
    errors: Record<string, any> | false;
    views: any[];
    availableRoles: any[];
    parent: number | null;
    item: ItemState;
    submitting: boolean;
    loading: boolean;
    showAddView: boolean;
}

export interface BlockFormProps {
    kedo: Kedo;
    item?: BlockItem;
    variant: 'new' | 'edit';
    onClose: () => void;
    onSuccess: (updated: boolean) => void;
}
